import { combineReducers } from 'redux';

import createPatient from './create-patient';
import getUser from './get-user';
import getLoggedUser from './get-logged-user';
import getTeamUser from './get-team-user';
import getProvider from './get-provider';
import getProviderMember from './get-provider-member';
import getParentMember from './get-parent-provider';
import getFamilyMember from './get-family-member';
import editUser from './edit-user';
import editAvatar from './edit-avatar';
import editPatient from './edit-patient';
import editPatientByProvider from './edit-patient-by-provider';
import editProvider from './edit-provider';
import editEmail from './edit-email';
import editMobilePhone from './edit-mobile-phone';
import confirmMobilePhone from './confirm-mobile-phone';
import changeSettings from './change-settings';
import changeProfileReq from './change-profile-req';
import addPatientByProvider from './addPatientByProvider';
import getAccessLevels from './getAccessLevels';
import publicProfile from './public-profile';
import getUserDocuments from './get-user-documents';
import getUserAttachments from './get-user-attachment';
import uploadUserDocuments from './upload-user-documents';
import updateUserDocuments from './update-user-documents';
import deleteUserDocuments from './delete-user-documents';
import deleteUserAttachment from './delete-user-attachment';
import deleteUserOutcomeAttachment from './delete-user-outcome-attachment';
import getGuardianDependent from './get-guardian-dependents';
import handleDocumentsErrors from './handle-documents-error-saga';
import profileEditable from './profile-editable-req';
import getMainConsent from './get-main-consent';
import addPatientData from './add-patient-data';
import editWorkingHours from './edit-working-hours';
import countryCode from './country-code';

// Patient Portal
import currentHealthboardOptions from './patientHealthboard/currentHealthboardOptions';
import vitalsActivity from './patientHealthboard/vitals-activity-req';
import historicMeasurements from './patientHealthboard/historic-measurements-req';
import stepsMeasurement from './patientHealthboard/steps-measurements-req';
import stepsMeasurementModal from './patientHealthboard/steps-measurements-modal-req';
import distanceMeasurement from './patientHealthboard/distance-measurements-req';
import distanceMeasurementModal from './patientHealthboard/distance-measurements-modal-req';
import bmiMeasurement from './patientHealthboard/bmi-measurements-req';
import bmiMeasurementModal from './patientHealthboard/bmi-measurements-modal-req';
import bloodGlucoseMeasurement from './patientHealthboard/blood-glucose-measurements-req';
import bloodGlucoseMeasurementModal from './patientHealthboard/blood-glucose-measurements-modal-req';
import weightMeasurement from './patientHealthboard/weight-measurements-req';
import weightMeasurementModal from './patientHealthboard/weight-measurements-modal-req';
import heightMeasurement from './patientHealthboard/height-measurements-req';
import heightMeasurementModal from './patientHealthboard/height-measurements-modal-req';
import saturationMeasurement from './patientHealthboard/saturation-measurements-req';
import saturationMeasurementModal from './patientHealthboard/saturation-measurements-modal-req';
import heartRateMeasurement from './patientHealthboard/heart-rate-measurements-req';
import heartRateMeasurementModal from './patientHealthboard/heart-rate-measurements-modal-req';
import bodySurfaceAreaMeasurement from './patientHealthboard/body-surface-area-measurements-req';
import bodySurfaceAreaMeasurementModal from './patientHealthboard/body-surface-area-measurements-modal-req';
import bloodPressureMeasurement from './patientHealthboard/bloodPressure-measurements-req';
import bloodPressureMeasurementModal from './patientHealthboard/bloodPressure-measurements-modal-req';
import respiratoryRateMeasurement from './patientHealthboard/respiratoryRate-measurements-req';
import respiratoryRateMeasurementModal from './patientHealthboard/respiratoryRate-measurements-modal-req';
import bodyTemperatureMeasurement from './patientHealthboard/body-temperature-measurements-req';
import bodyTemperatureMeasurementModal from './patientHealthboard/body-temperature-measurements-modal-req';
import singleDayGrafModal from './patientHealthboard/single-day-graf-modal';
import singlePointValuesModal from './patientHealthboard/single-point-values-modal';
import addWeightData from './patientHealthboard/add-weight-data';
import addHeightData from './patientHealthboard/add-height-data';
import addDataModal from './patientHealthboard/add-data-modal';
import connectedDevices from './patientHealthboard/connected-devices';
import providerAuthentications from './patientHealthboard/provider-authentications';
import providerList from './patientHealthboard/provider-list';
import removeAccount from './patientHealthboard/remove-account';
import googleFitModal from './patientHealthboard/google-fit-modal';
import manualActivateInsuranceEligibility from './insurance-eligibility-manual-activations';
import editPatientEmergencyContact from './edit-patient-emergency-contact';

// MFA
import enableMfa from './mfa-enable';
import disableMfa from './mfa-disable';
import mfaConfirmation from './mfa-confirmations';
import mfaNotice from './mfa-notice';

export default combineReducers({
  addPatientByProvider,
  addPatientData,
  changeSettings,
  confirmMobilePhone,
  countryCode,
  createPatient,
  deleteUserAttachment,
  deleteUserDocuments,
  deleteUserOutcomeAttachment,
  disableMfa,
  editAvatar,
  editEmail,
  editMobilePhone,
  editPatient,
  editPatientByProvider,
  editProvider,
  editUser,
  editWorkingHours,
  enableMfa,
  getAccessLevels,
  getFamilyMember,
  getGuardianDependent,
  getLoggedUser,
  getMainConsent,
  getParentMember,
  getProvider,
  getProviderMember,
  getTeamUser,
  getUser,
  getUserAttachments,
  getUserDocuments,
  handleDocumentsErrors,
  manualActivateInsuranceEligibility,
  mfaConfirmation,
  mfaNotice,
  profileEditable,
  publicProfile,
  updateUserDocuments,
  uploadUserDocuments,
  editPatientEmergencyContact,
  patientHealthboard: combineReducers({
    googleFitModal,
    currentHealthboardOptions,
    addDataModal,
    addHeightData,
    addWeightData,
    vitalsActivity,
    historicMeasurements,
    stepsMeasurement,
    stepsMeasurementModal,
    distanceMeasurement,
    distanceMeasurementModal,
    bmiMeasurement,
    bmiMeasurementModal,
    bloodGlucoseMeasurement,
    bloodGlucoseMeasurementModal,
    weightMeasurement,
    weightMeasurementModal,
    heightMeasurement,
    heightMeasurementModal,
    singleDayGrafModal,
    singlePointValuesModal,
    connectedDevices,
    providerAuthentications,
    providerList,
    removeAccount,
    saturationMeasurement,
    saturationMeasurementModal,
    changeProfileReq,
    heartRateMeasurement,
    heartRateMeasurementModal,
    bodySurfaceAreaMeasurement,
    bodySurfaceAreaMeasurementModal,
    bloodPressureMeasurement,
    bloodPressureMeasurementModal,
    respiratoryRateMeasurement,
    respiratoryRateMeasurementModal,
    bodyTemperatureMeasurement,
    bodyTemperatureMeasurementModal,
  }),
});



// WEBPACK FOOTER //
// ./src/redux/profiles/index.js